import Collapse from "./v-collapse.vue";

/* istanbul ignore next */
Collapse.install = function install(Vue) {
  Vue.component(Collapse.name, Collapse);
};

export default Collapse;
